import { useEffect } from "react";

const ensureMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== "content") el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  if (attrs.content !== undefined) el.setAttribute("content", attrs.content);
  return el;
};

const ensureLink = (rel) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
};

const ensureJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const useSeo = ({
  title,
  description,
  canonical,
  ogImage,
  ogType = "website",
  jsonLd,
  jsonLdId = "page-jsonld",
}) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      ensureMeta('meta[name="description"]', {
        name: "description",
        content: description,
      });
      ensureMeta('meta[property="og:description"]', {
        property: "og:description",
        content: description,
      });
      ensureMeta('meta[name="twitter:description"]', {
        name: "twitter:description",
        content: description,
      });
    }

    if (title) {
      ensureMeta('meta[property="og:title"]', {
        property: "og:title",
        content: title,
      });
      ensureMeta('meta[name="twitter:title"]', {
        name: "twitter:title",
        content: title,
      });
    }

    ensureMeta('meta[property="og:type"]', {
      property: "og:type",
      content: ogType,
    });

    if (ogImage) {
      ensureMeta('meta[property="og:image"]', {
        property: "og:image",
        content: ogImage,
      });
      ensureMeta('meta[name="twitter:image"]', {
        name: "twitter:image",
        content: ogImage,
      });
    }

    if (canonical) {
      ensureLink("canonical").setAttribute("href", canonical);
      ensureMeta('meta[property="og:url"]', {
        property: "og:url",
        content: canonical,
      });
    }

    if (jsonLd) {
      ensureJsonLd(jsonLdId, jsonLd);
    } else {
      const old = document.getElementById(jsonLdId);
      if (old) old.remove();
    }
  }, [title, description, canonical, ogImage, ogType, jsonLd, jsonLdId]);
};
